



































import { Component, Prop, Vue } from "vue-property-decorator";
import { DxPopup, DxToolbarItem } from "devextreme-vue/popup";
import ProjectCommunicationTable from "@/modules/projects/components/communication/ProjectCommunicationTable.vue";
import { DxScrollView } from "devextreme-vue";

@Component({
  components: {
    DxPopup,
    ProjectCommunicationTable,
    DxScrollView,
    DxToolbarItem,
  },
})
export default class CommunicationPopup extends Vue {
  private project: any = {};
  private show: boolean = false;
  private fullscreen: boolean = false;

  public open(projectId: string) {
    this.project.id = projectId;
    this.show = true;
  }

  public hide() {
    this.project = {};
    this.show = false;
  }
}
